<template>
    <div
        class="border-b border-border-darker/40 py-6 flex items-center gap-x-4"
    >
        <Link :href="url" :class="{ 'rounded-full': rounded }">
            <ModelImage
                :src="imageSrc"
                :modelClass="modelClass"
                imageClasses="object-cover w-full h-full"
                :clickable="true"
                :class="[
                    rounded ? 'rounded-full' : 'rounded',
                    'size-14 aspect-square flex-shrink-0',
                ]"
                :fallbackBorder="
                    rounded ? `border border-${modelClass}-accent` : 'border'
                "
            />
        </Link>
        <div class="flex flex-col gap-y-1 justify-center">
            <Link :href="url" v-text="name" class="underline-hover" />
            <Link
                v-if="parentUrl"
                :href="parentUrl"
                v-text="parentName"
                class="underline-hover text-sm text-text-secondary"
            />
        </div>
    </div>
</template>

<script>
import ModelImage from '@/Components/ModelComponents/ModelImage.vue'
import { Link } from '@inertiajs/vue3'

export default {
    name: 'UserOrganizationPresentation',

    components: {
        ModelImage,
        Link,
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        imageSrc: {
            type: [String, null],
            default: null,
        },
        url: {
            type: String,
            required: true,
        },
        parentUrl: {
            type: String,
            required: false,
        },
        parentName: {
            type: String,
            required: false,
        },
    },

    computed: {
        rounded() {
            return this.modelClass === 'user'
        },
    },
}
</script>
